import React from 'react';

export const Refresh: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 13.3356C9.95426 13.3357 11.7522 12.2675 12.6866 10.5511"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3356 8C13.3356 5.05325 10.9467 2.66444 8 2.66444"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99985 2.66444C6.04559 2.66428 4.24761 3.73253 3.31323 5.44894"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66431 8C2.66431 10.9467 5.05312 13.3356 7.99986 13.3356"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.31323 5.44894C4.47955 3.3056 6.95128 2.22659 9.316 2.82851C11.6807 3.43043 13.3358 5.55988 13.3354 8.00001"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66431 8C2.66393 10.4401 4.31899 12.5696 6.68371 13.1715C9.04843 13.7734 11.5202 12.6944 12.6865 10.5511"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.36351 5.44894H3.00586V3.09062"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6362 10.5511H12.9939V12.9094"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
